//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "user",
  computed: {
    userFullName: function () {
      let fullName = "";
      if (this.$auth.user) {
        if (this.$auth.user.lastName) {
          fullName += this.$auth.user.lastName;
        }
        if (this.$auth.user.firstName) {
          fullName += " " + this.$auth.user.firstName;
          //fullName += " " + (this.$auth.user.firstName).substr(0, 1) + '.';
        }
        if (this.$auth.user.middleName) {
          fullName += " " + this.$auth.user.middleName;
        }
      }
      return fullName;
    },
    regnumber: function() {
      return this.$auth.user?.hasOwnProperty('regnumber') ? this.$auth.user.regnumber : ''
    },
    userUid: function () {
      return this.$auth.user?.guid ? this.$auth.user.guid : "";
    },
    photo: function () {
      return this.$auth.user?.photo ? this.$auth.user.photo : '/img/icons/no-photo.svg';
    },
    applicationNumber() {
      return this.$store.getters['competition/getNumber']
    },
  },
  methods: {
    async logout() {
      this.$store.commit('logout/setLogout', true)
      await this.$router.push({path:  '/'})
    },
  },
  data: () => ({
    name: 'Константинопольский К.',
    subtitle: '066689',
    link: ""
  }),
}
